import { render } from "./RpmDraggable.vue?vue&type=template&id=5e5436f0"
import script from "./RpmDraggable.vue?vue&type=script&lang=js"
export * from "./RpmDraggable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__